import React from "react";
import { InformationIcon } from "./icons/InformationIcon";

export function NoData(props: NoDataProps) {
    const { message } = props;

    return (
        <div className="no_data">
            <InformationIcon/>
            <div className="message">
                { message !== undefined ? message : "データがありません"}
            </div>
        </div>
    );
}

export type NoDataProps = {
    message? : string,
    backLink? : string
};
